if (typeof window === 'undefined') {
    collectionsMetrics(
        module.exports,
        require('backbone'),
        undefined,
        require('lodash')
    );

} else {
    RivalIQ.module('collections', function () {});
    collectionsMetrics(
        RivalIQ.collections,
        window.Backbone,
        window.$,
        window._
    );
}

function collectionsMetrics(collections, Backbone, $, _) {
    'use strict';

    function getModels() {
        return (typeof window === 'undefined' ? require('../models/metric.js') : RivalIQ.models);
    }

    function getMetrics() {
        return (typeof window === 'undefined' ? require('../metrics.js') : RivalIQ.metrics);
    }

    collections.MetricDefinitions = Backbone.Collection.extend({
        model: function (attrs, options) {
            const models = getModels();
            const model = new models.MetricDefinition(attrs, options);
            model.collection = options.collection;
            return model;
        },

        _isModel: function (model) {
            const models = getModels();
            return model instanceof models.MetricDefinition;
        },

        get: function (obj) {
            const me = this;
            const metrics = getMetrics();

            if (_.isString(obj) && metrics.descriptions[obj]) {
                obj = metrics.descriptions[obj];
            }

            const id = me.modelId(me._isModel(obj) ? obj.id : obj);
            return me._byId[obj] || me._byId[id] || me._byId[obj.cid];
        },

        /*
         * Builds a metrics collection by fetching the appropriate
         * data. Returns a deferred
         *
         * We attempt to be thrifty by combining as many calls to fetch company
         * data as our api allows. Other metrics are currently fetched
         * independently, though they will share a request if all of the cache
         * keys match
         */
        fetch: function (attrs) {
            const me = this;

            if (attrs instanceof RivalIQ.collections.CompanyData) {
                return new collections.Metrics(me.toArray(), {
                    companyData: attrs
                });
            }

            // TODO BUG If you mix metrics with different dataSouces in
            // a collection, the resulting Metric collection will not have its
            // order preserved
            const metricDeferreds = _.map(me.groupBy('dataSource'), function (definitions, dataSource) {
                if (!dataSource) {
                    return fetchCompanyDataForMetrics(attrs, definitions)
                        .then(function (companyData) {
                            return _.map(definitions, function (definition) {
                                return definition.fetch(companyData);
                            });
                        });
                }

                // NOTE this is an optimization to make sure that if this call
                // occurs outside of a cache/batching context that we will only
                // make one request to the Universal Metrics API, rather than N
                // (where N is the number of metrics that have enabled the flag
                // to use the Universal Metrics API). a narrow real world
                // case that this approach solves is captured in #20116; there
                // are likely more cases we don't know about yet.

                const requests = _.reduce(definitions, function (memo, definition, i) {
                    if (!definition.get('useUniversalMetricsApi')) {
                        memo.legacy.push(definition.fetch(attrs));
                    } else {
                        memo.universal.push([i, definition]);
                    }
                    return memo;
                }, {
                    universal: [],
                    legacy: []
                });

                return $.when(
                    $.when.apply($, requests.legacy),
                    RivalIQ.universal.fetch(attrs, _.map(requests.universal, _.last))
                ).then(function (legacy, universal) {
                    const models = (legacy || []);
                    _.each(requests.universal, function (request) {
                        const idx = _.head(request);
                        models.splice(idx, 0, universal.shift());
                    });
                    return models;
                });
            });

            return $.when.apply(null, _.flatten(metricDeferreds)).then(function () {
                return new collections.Metrics(_.flatten(arguments));
            });
        },

        getSource: function () {
            const me = this;
            return _.uniq.call(_, me.invoke('getSource'));
        },

        // TODO what about conflicting params?
        getParameters: function () {
            const me = this;
            return _.extend.apply(_, me.invoke('getParameters'));
        },

        toJSON: function () {
            const me = this;
            return me.map(function (model) { return model.toType(); });
        },

        getColumnSortOrder: function (orderBy) {
            const me = this;
            const range = _.range(0, me.length);

            // Turn orderBy into an array of column indices
            orderBy = _.uniq(_.map(_.isArray(orderBy) ? orderBy : [orderBy], function (idx) {
                return (me.length <= Number(idx) ? 0 : Number(idx));
            }));

            // Fill in with all other columns for tiebreaking
            orderBy = _.union(_.intersection(orderBy, range), range);

            // Filter out columns that are not sortable
            orderBy = _.reject(orderBy, function (idx) {
                return me.at(idx).get('sortable') === false;
            });

            return (orderBy.length ? orderBy : [0]);
        },

        // Turn an orderBy index / array into a property name for the server
        getOrderBy: function (orderByIndices) {
            const me = this;

            const idx = me.getColumnSortOrder(orderByIndices)[0];
            // NOTE idx can be undefined for mobile views when sortable columns
            // have been elided, so in that case return undefined
            return (_.isFinite(idx) ? me.at(idx).getOrderBy() : undefined);
        }
    });

    collections.Metrics = Backbone.Collection.extend({
        model: function (attrs, options) {
            const models = getModels();
            let model;

            if (attrs instanceof models.MetricDefinition) {
                model = attrs.getMetric(options.companyData);
            } else {
                model = new models.Metric(attrs, options.companyData);
            }
            model.collection = options.collection;

            return model;
        },

        _isModel: function (model) {
            const models = getModels();
            return model instanceof models.Metric;
        },

        modelId: function (attrs) {
            return attrs.cid;
        },

        filterValues: function (options) {
            const me = this;
            options = options || {};

            const results = me.filter(function (definition) {
                return _.exists(definition.getValue({
                    format: false
                }));
            });

            // sort descending before applying limit
            return _(results)
                .sortBy(function (definition) {
                    return -1 * (definition.isOther() ? Number.MIN_VALUE : definition.getValue({
                        format: false
                    }));
                })
                .take(options.limit || results.length)
                .value();
        }
    });

    collections.LazyMetricDefinitions = collections.MetricDefinitions.extend({
        initialize: function (attrs, options) {
            const me = this;
            _.extend(me, options);
        },

        getSource: function () {
            const me = this;
            return me.dimension.getSource();
        },

        getParameters: function () {
            const me = this;
            return me.dimension.getParameters();
        },

        fetch: function (companyData) {
            const me = this;
            return me.dimension.getDimensions().fetch(companyData);
        }
    });

    collections.MetricDefinitions.fetch = function (attrs, definitions) {
        return fetchCompanyDataForMetrics(attrs, definitions)
            .then(function (companyData) {
                return _.map(definitions, function (definition) {
                    return (definition ? definition.fetch(companyData) : definition);
                });
            });
    };

    function fetchCompanyDataForMetrics(attrs, definitions) {
        const parameters = {};
        let sources = [];

        _.each(_.compact(definitions), function (definition) {
            _.extend(parameters, definition.getParameters());
            sources = sources.concat(definition.getSource());
        });

        attrs = _.defaults(_.extend({}, attrs, parameters), {
            sources: _.compact(_.uniq(sources))
        });

        return RivalIQ.data.companyData.fetch(attrs, _.omit(attrs, 'timePeriod'));
    }
}
